// api/DendreoLog.ts
import { Model, Attr } from 'spraypaint';
import dayjs, { Dayjs } from 'dayjs';
import ApplicationRecord from '../ApplicationRecord';

@Model()
class DendreoLog extends ApplicationRecord {
  static jsonapiType = 'dendreo-logs';

  // Attributes
  @Attr({ persist: false }) timestamp!: string;
  @Attr({ persist: false }) status!: string;
  @Attr({ persist: false }) source!: string;
  @Attr({ persist: false }) message!: string;
  @Attr({ persist: false }) payload!: unknown;
  @Attr({ persist: false }) trace!: string;
  @Attr({ persist: false }) title!: string;

  // Extra-attributes

  // Relationships

  get timestampDayjs(): Dayjs | null {
    if (!this.timestamp) return null;
    return dayjs(this.timestamp);
  }
}

export default DendreoLog;
